import Modal from './lib/Modal';

export default Modal;
